import { type AuthMeResponse, type UserStatus } from "@/features/auth/model/auth-types"

export const ACCOUNT_BLOCKED_PATH = "/account-blocked"

export const canAccessSystem = (status: UserStatus | null | undefined) =>
  status === "ACTIVE"

export function getAuthMeUserStatus(authMe: AuthMeResponse | null | undefined) {
  return authMe?.user?.status
}

